import { selectProfessionalSportState } from "@app/shared/store/reducers";
import * as fromProfessionalSport from "@app/shared/store/reducers/professional-sport.reducer";
import { createSelector } from "@ngrx/store";

export const selectProfessionalSportListIsLoading = () =>
  createSelector(
    selectProfessionalSportState(),
    fromProfessionalSport.selectIsLoading,
  );

export const selectProfessionalSportEntities = () =>
  createSelector(
    selectProfessionalSportState(),
    fromProfessionalSport.selectProfessionalSportEntities,
  );

export const selectProfessionalSportList = () =>
  createSelector(
    selectProfessionalSportState(),
    fromProfessionalSport.selectProfessionalSportList,
  );
